/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Ready_For_PickupInputs */

const en_status_ready_for_pickup = /** @type {(inputs: Status_Ready_For_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for Pickup`)
};

const es_status_ready_for_pickup = /** @type {(inputs: Status_Ready_For_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para recoger`)
};

/**
* | output |
* | --- |
* | "Ready for Pickup" |
*
* @param {Status_Ready_For_PickupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_ready_for_pickup = /** @type {((inputs?: Status_Ready_For_PickupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Ready_For_PickupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_ready_for_pickup(inputs)
	return es_status_ready_for_pickup(inputs)
});